export default __webpack_public_path__ + "static/1365-6439e0b7e5479b74a0593af1b164db3c.gif";